import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { QFormControl, QMultiSelect, QSelectPlaceholder, QText } from '@qualio/ui-components';
import { EventTag } from '../../../types';
import TagItemLabel from './TagItemLabel';
import { EMPTY_FILTER_VALUE } from '../../../types/qualityEvent';

export const TagFilter = ({
  isLoadingTags,
  tags,
  isAdditionalEventListFiltersEnabled = false,
}: {
  isLoadingTags: boolean;
  tags: EventTag[];
  isAdditionalEventListFiltersEnabled?: boolean;
}) => {
  const { t } = useTranslation();
  const tagsOptions = [
    ...(isAdditionalEventListFiltersEnabled
      ? [{ value: EMPTY_FILTER_VALUE, label: <em>{t('common.labels.emptyTags')}</em> }]
      : []),
    ...tags.map((tag) => ({
      value: tag.id.toString(),
      label: <TagItemLabel tag={tag} />,
    })),
  ];

  const tagFilter = useCallback((option: any, searchText: string) => {
    if (!searchText) {
      return true;
    }
    if (option.data.value === EMPTY_FILTER_VALUE) {
      const emptyLabelText = String(option.data.label?.props?.children ?? '').toLowerCase();
      return emptyLabelText.includes(searchText.toLowerCase());
    }
    const tagName = option.data.label.props.tag.name;
    if (tagName.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    }
    return false;
  }, []);

  return (
    <QFormControl label={t('common.labels.tags')} data-cy="tags-filter" w="300px">
      <Controller
        name={'filter_tags'}
        render={({ field: { onChange, value } }) => {
          return (
            <QMultiSelect
              options={tagsOptions}
              aria-label="tags-filter"
              onChange={(val) => onChange(val.map((c) => c.value))}
              value={value ?? []}
              isLoading={isLoadingTags}
              filterOption={tagFilter}
            >
              <QSelectPlaceholder>
                <QText>{t('common.filters.filterByTags')}</QText>
              </QSelectPlaceholder>
            </QMultiSelect>
          );
        }}
      />
    </QFormControl>
  );
};

export default TagFilter;
